// DCL-462: warn a logged-in user when the email provider has suppressed
// (blacklisted) their address. checkAndNotify() runs at most once per session
// (in-memory flag, same idiom as AccountSetupActions) and only toasts when the
// user's notification preference says they expect email.
angular.module('dentalLinks')
.factory('EmailSuppressionWarning', ['UserEmailSuppression', 'Notification', 'Auth', '$uibModal', 'ModalHandler', '$sce',
    function (UserEmailSuppression, Notification, Auth, $uibModal, ModalHandler, $sce) {
        var checkedThisSession = false;

        // The toast body is $compile'd against NotificationAreaController's scope
        // (index.html's `dynamic-html`), and AngularJS 1.8 has no expression
        // sandbox — a `{{ }}` sequence surviving into the compiled nodes runs.
        // Escaping cannot close that: element.html() decodes `&#123;` back to `{`
        // before interpolation. So the message stays a static string and every
        // value from the server is handed over in params and bound with ng-bind,
        // which writes text content and is never re-compiled. trustAsHtml is what
        // lets dynamic-html compile it (DCL-702), so it stays a constant.
        var TOAST_MESSAGE = $sce.trustAsHtml(
            'You are currently <strong>not receiving email notifications</strong>. ' +
            'Our email provider stopped delivering to ' +
            '<strong ng-bind="notification.params.email"></strong> ' +
            'after a delivery failure (<span ng-bind="notification.params.suppressionType"></span>), ' +
            'even though your notification preference is set to receive them. ' +
            '<a href="" ng-click="notificationAction()">See details</a>');

        function openDetailsDialog(userId, suppression, onRemoved) {
            var modalInstance = $uibModal.open({
                templateUrl: 'partials/email_suppression_details.html',
                controller: 'EmailSuppressionDetailsModalController',
                resolve: {
                    userId: function () { return userId; },
                    suppression: function () { return suppression; }
                }
            });
            ModalHandler.set(modalInstance);
            modalInstance.result.then(function (result) {
                if (result === 'removed' && onRemoved) {
                    onRemoved();
                }
            }, angular.noop); // dismissing the dialog is not an error
        }

        function checkAndNotify() {
            var auth = Auth.get();
            if (!auth || !auth.id) {
                return;
            }
            if (checkedThisSession) {
                return;
            }
            checkedThisSession = true;

            UserEmailSuppression.get({id: auth.id}, function (data) {
                if (!data.suppressed || data.notification_preference === 0) {
                    return;
                }
                // DCL-482: suppressions are scoped to the provider's sending
                // stream, and DCL notifications go out on the transactional
                // stream. A bulk-only suppression (e.g. a marketing-blast
                // unsubscribe) does not block notifications, so the toast's
                // claim would be false. The Edit User banner still surfaces it.
                if (data.sending_stream === 'bulk') {
                    return;
                }
                Notification.warning(
                    TOAST_MESSAGE,
                    {
                        dontHideOnRequest: true,
                        email: data.email,
                        suppressionType: data.suppression_type,
                        // No onRemoved hook: Notification holds a single slot, so
                        // the dialog's success toast already replaces this warning
                        // on removal. Dismissing here would run after that and wipe
                        // the only confirmation the user gets.
                        //
                        // DCL-483: dismiss on the way into the dialog instead. The
                        // toast is dontHideOnRequest, so left alone it stays behind
                        // the modal backdrop for the rest of the session; following
                        // its link is the user acting on it, which is the toast's
                        // whole purpose. Only this callback dismisses —
                        // openDetailsDialog is also the Edit User dialog's handler,
                        // where the single notification slot may hold something else.
                        action: function () {
                            Notification.dismiss();
                            openDetailsDialog(auth.id, data);
                        }
                    }
                );
            }, angular.noop); // a failed check must never break the page
        }

        // Logout and impersonation start/stop are $state reloads, not page
        // reloads, so this service instance outlives the identity that armed the
        // flag. Callers that switch identity must reset (and dismiss the toast,
        // which is dontHideOnRequest and would otherwise show one user's address
        // to the next person at the same workstation).
        function reset() {
            checkedThisSession = false;
        }

        return {
            checkAndNotify: checkAndNotify,
            openDetailsDialog: openDetailsDialog,
            reset: reset
        };
    }]);
